export const weatherVariablesType = {
  maxWindGust: 'maxWindGust',
  maxWindSpeed: 'maxWindSpeed',
  averageWindDirection: 'averageWindDirection',
  averageTemperature: 'averageTemperature',
  totalPrecipitation: 'totalPrecipitation',
  windSpeed: 'windSpeed',
  windGust: 'windGust',
  windDirection: 'windDirection',
  temperature: 'temperature',
  precipitation: 'precipitation',
};

export const eventWeatherVariablesOrder = [
  weatherVariablesType.maxWindSpeed,
  weatherVariablesType.maxWindGust,
  weatherVariablesType.averageTemperature,
  weatherVariablesType.totalPrecipitation,
];

export const units = {
  metersPerHour: 'mph',
  degree: '°',
  degreeCelcius: '°C',
  precipitationMeter: 'mm',
};

const weatherVariablesOrder = [
  'weatherSummary',
  'faultBand24h',
  'faultBand',
  'confidence',
  weatherVariablesType.maxWindSpeed,
  weatherVariablesType.maxWindGust,
  weatherVariablesType.averageWindDirection,
  weatherVariablesType.averageTemperature,
  weatherVariablesType.totalPrecipitation,
];
export default weatherVariablesOrder;

export const allRolesAvailable = [
  'User',
  'Super User',
  'IT Admin',
  'Control Room',
];

export const roles = {
  user: 'User',
  superUser: 'Super User',
  itAdmin: 'IT Admin',
  controlRoom: 'Control Room',
};

export const weatherUnit = {
  wind: 'mph',
  temperature: '°C',
  precipitation: 'mm',
};

export const weatherType = {
  wind: 'wind', // wind speed
  i10fg: 'i10fg', // wind gust
  t2m: 't2m', // temperature
  tp: 'tp', // precipitation
};

export const challengesOptionsActionPlan = {
  availabilityPlant: 'Availability of plant',
  availabilityHeavyTeams: 'Availability of heavy teams',
  availabilityNewsacResources: 'Availability of NEWSAC resources',
};

export const typeOfActionValue = {
  edit: 'edit',
  validate: 'validate',
};

export const eventStatusValue = {
  validated: 'validated',
  updating: 'updating',
  pending: 'pending',
  disabled: 'disabled',
  error: 'error',
};

export const weatherEventFieldName = {
  logisticResourceChallenges: 'logisticResourceChallenges',
  comments: 'comments',
  teafGenerators: 'teafGenerators',
  eacStaff: 'eacStaff',
  outLicence: 'outLicence',
  compensationsPaid: 'compensationsPaid',
  customersOff24h: 'customersOff24h',
};

export const maxImageSizeMb = 2;
